const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Dia `dd/mm/aaaa` sem passar pelo fuso: "2026-10-04" viraria 03/10 com
 * `new Date(...)` em BRT. Prazos da API chegam como dia ou ISO.
 */
export const formatDay = (value) => {
    if (!value) return "—";
    const match = String(value).match(ISO_DAY);
    if (match) return `${match[3]}/${match[2]}/${match[1]}`;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("pt-BR");
};

export const formatDayMonth = (value) => {
    const day = formatDay(value);
    return day === "—" ? null : day.slice(0, 5);
};

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString("pt-BR") : "—");
